// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3wVLB","top":"styles_top__nHbKA","left":"styles_left__KmoOR","description":"styles_description__W0i81"};